import generateWithAsyncActions from 'epic-alt-utils';
import alt from 'epic-fortnite-react/alt';

export default generateWithAsyncActions(alt, ['getArchivePages', 'clearErrorStatus']);
